import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import PageBanner from '@component/PageBanner';

const BannerComponent = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;
  return (
    <>
      {isEditing || props.fields?.bannerimage?.value?.src ? (
        <PageBanner bannerText={<Text field={props.fields?.title} />} imageInfo={<Image field={props.fields?.bannerimage} />} />
      ) : null}
    </>
  );
};
export default BannerComponent;
